<div class="flex justify-between items-start">
  <div class="mx-auto flex flex-col items-center mt-2">
    <h2 class="text-3xl font-medium text-secondary font-sans flex" mat-dialog-title>
      {{ 'mortgage.calculation.select_tab' | translate }}
    </h2>

  </div>
  <div class="flex flex-col items-end">
    <button class="rounded-md" mat-button [autofocus]="false" [mat-dialog-close]="true">
      <mat-icon class="text-3xl">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="mat-typography -mx-6">
  <div class="kfp-form">



    <div class="flex flex-wrap justify-center">
      @for (calc of calculations.items; track calc; let i = $index) {
        <div class="max-w-sm rounded-lg overflow-hidden border border-gray-300 mx-2 my-2 cursor-pointer transform hover:scale-110" (click)="resp[i] = !resp[i]">
          <div class="px-6 py-4">
            <label class="custom-checkbox">
              <input 
                type="checkbox" 
                [(ngModel)]="resp[i]" 
                [name]="'checkbox-' + i"
                class="custom-checkbox-input"
              />
              <span class="custom-checkbox-label">{{calc.name}}</span>
            </label>
          </div>
        </div>
      }
    </div>




  </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button (click)="submit()" class="bg-secondary h-12 text-lg font-normal text-white rounded-md" mat-button>
    <span>{{ 'mortgage.calculation.set_selected' | translate }}</span>
  </button>
</mat-dialog-actions>
